import React from 'react'
import { AccordionComponet } from '../components/accordion.components'


export const AccordionContainer = ({headerTitle,expandedPanel,child}:any) => {
 
    return (
    <div>
        <AccordionComponet 
        headerTitle={headerTitle} 
        expandedPanel={expandedPanel}
        child={child}
        />
    </div>
  )
}